module.exports = __webpack_public_path__ + "assets/images/mastery-change-up-icon.f50fdcccf7190cb31dea33b901caf4fc.svg";